export const ChatswoodBuildings = () => {
  return (
    <iframe
      src="https://dokooy1qg41br.cloudfront.net/index.html"
      className="h-screen w-full border-none"
      title="Chatswood Buildings Demo"
    />
  );
};
